export default {
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 2,
  },
  iconButton: {
    minWidth: 0,
    width: 40,
    height: 40,
    flexShrink: 0,
  },
  iconHighlighted: {
    color: 'white',
  },
  icon: {
    fontSize: 24,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    mt: 2,
  },
  editorLabel: {
    mb: 0.5,
  },
  textField: {
    '& .MuiInputBase-root': {
      fontSize: '14px',
      fontWeight: 300,
      lineHeight: 1,
      px: 0,
      '& > svg': {
        marginLeft: 1,
        marginRight: 1.25,
        height: 24,
        minHeight: 24,
        minWidth: 24,
        width: 24,
      },
    },
    '& .MuiInputBase-input': {
      py: 1.25,
      '&::placeholder': {
        color: 'text.grey.blue_1',
        opacity: 1,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'background.light',
    },
  },
  selectWrapper: {
    position: 'relative',
    '& .MuiFormLabel-root': {
      fontSize: '14px',
      fontWeight: 300,
      paddingLeft: '28px',
    },
    '& .MuiInputLabel-shrink': {
      pl: 0,
    },
    '& .MuiSelect-select': {
      paddingLeft: '42px',
    },
    '& .MuiListItemText-root': {
      my: 0,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'background.light',
    },
  },
  selectIcon: {
    position: 'absolute',
    left: '0',
    top: '50%',
    transform: 'translate(8px,-50%)',
    display: 'flex',
    '& svg': {
      height: 24,
      minHeight: 24,
      minWidth: 24,
      width: 24,
    },
  },
  checkboxWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
  },
  checkbox: {
    color: 'text.brand.color_2',
    p: 1,
    '&.Mui-checked': {
      color: 'text.brand.color_2',
    },
  },
  checkboxLabel: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1,
    m: 0,
    gap: 0.5,
  },
  actionsWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: 1,
    paddingRight: '120px',
  },
  editorWrapper: {
    width: '100%',
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .tox-tinymce': {
      border: '1px solid',
      borderColor: '#EDEFF0',
      borderRadius: 2,
    },
    '& div.tox-editor-header:nth-child(n)': {
      boxShadow: 'none',
      borderBottom: '1px solid',
      borderColor: '#EDEFF0',
    },
  },
};
